const TwitterIcon = () => {
  return <img style={{ height: '25px' }} alt="" src="/images/twitter.svg" />;
};

TwitterIcon.displayName = 'TwitterIcon';

export default TwitterIcon;
